import React, { useState, useMemo, useEffect } from 'react';
import { PulseLoader } from '../loader/pulse';
import { Tooltip } from '../ui/Tooltip';
import Style from './GenericTable.module.scss';

// ── Icons ─────────────────────────────────────────────────────────────────────

function IcoWrite() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9" /><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z" /></svg>;
}
function IcoTrash() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6" /><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" /><path d="M10 11v6M14 11v6" /><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" /></svg>;
}
function IcoEye() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" /><circle cx="12" cy="12" r="3" /></svg>;
}
function IcoMapPin() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>;
}
function IcoCheck() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>;
}
function IcoPower() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2v10" /><path d="M18.4 6.6a9 9 0 1 1-12.8 0" /></svg>;
}
function IcoUpload() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>;
}
function IcoDocument() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /><line x1="16" y1="13" x2="8" y2="13" /><line x1="16" y1="17" x2="8" y2="17" /></svg>;
}
function IcoRetry() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="1 4 1 10 7 10" /><path d="M3.51 15a9 9 0 1 0 .49-4.5" /></svg>;
}
function IcoLock() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;
}
function IcoUnlock() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 9.9-1" /></svg>;
}
function IcoAgreement() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4" /><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11" /></svg>;
}
function IcoRestore() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" /><path d="M3 3v5h5" /></svg>;
}
function IcoBell() {
  return <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" /><path d="M13.73 21a2 2 0 0 1-3.46 0" /></svg>;
}
function IcoChevLeft() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
}
function IcoChevRight() {
  return <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;
}
// Marca de orden: un solo caret, tenue cuando la columna no esta ordenada.
function SortMark({ active, direction }) {
  return (
    <svg
      width="10" height="10" viewBox="0 0 24 24" fill="none"
      stroke={active ? DS.onSurface : DS.outlineVariant}
      strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
      style={{
        flexShrink: 0,
        transform: active && direction === 'desc' ? 'rotate(180deg)' : 'none',
        transition: 'transform 0.15s, stroke 0.15s',
      }}
    >
      <polyline points="18 15 12 9 6 15" />
    </svg>
  );
}

// ── Tokens del design system ──────────────────────────────────────────────────
const DS = {
  primary:        '#FFB800',
  onPrimary:      '#1E293B',
  surface:        '#FFFFFF',   // superficie de tarjeta
  container:      '#F1F5F9',   // cabecera de tabla, hover de fila
  outline:        '#E2E8F0',
  outlineSoft:    '#E2E8F0',
  divider:        '#E2E8F0',
  onSurface:      '#1E293B',
  onVariant:      '#475569',
  muted:          '#94A3B8',
  shadow:         '0 2px 4px rgba(0, 0, 0, 0.05)',
};

const TABLE_FONT = 'inherit';
const TABLE_ROW_HEIGHT = 36;   // alta densidad: 8px vertical sobre 13px

// ── Circular action button ────────────────────────────────────────────────────

const ACTION_CFG = {
  view: { icon: <IcoEye />, label: 'Ver', hover: '#6366f1' },
  edit: { icon: <IcoWrite />, label: 'Editar', hover: '#3b82f6' },
  delete: { icon: <IcoTrash />, label: 'Eliminar', hover: '#ef4444' },
  map: { icon: <IcoMapPin />, label: 'Ubicación', hover: '#d97706' },
  activate: { icon: <IcoCheck />, label: 'Activar', hover: '#22c55e' },
  detail: { icon: <IcoEye />, label: 'Ver Detalle', hover: '#6366f1' },
  deactivate: { icon: <IcoPower />, label: 'Inactivar', hover: '#f97316' },
  upload: { icon: <IcoUpload />, label: 'Subir comprobante', hover: '#22c55e' },
  receipt:   { icon: <IcoDocument />, label: 'Ver comprobante',         hover: '#2563eb' },
  approve:   { icon: <IcoCheck />,    label: 'Aprobar pago',             hover: '#22c55e' },
  retry:     { icon: <IcoRetry />,    label: 'Reintentar SRI',           hover: '#f59e0b' },
  block:     { icon: <IcoLock />,     label: 'Bloquear rutas',           hover: '#dc2626' },
  unblock:   { icon: <IcoUnlock />,   label: 'Desbloquear rutas',        hover: '#22c55e' },
  agreement: { icon: <IcoAgreement />,label: 'Acuerdo de pago',          hover: '#6366f1' },
  restore:   { icon: <IcoRestore />,  label: 'Restaurar cliente',         hover: '#16a34a' },
  notify:    { icon: <IcoBell />,     label: 'Enviar notificación',      hover: '#2563eb' },
};

function ActionBtn({ type, onClick, disabled, disabledTooltip }) {
  const cfg = ACTION_CFG[type] || { icon: null, label: type, hover: '#3b82f6' };
  const [hov, setHov] = useState(false);
  const tooltipText = disabled ? (disabledTooltip || cfg.label) : cfg.label;

  return (
    <Tooltip text={tooltipText} position="top" delay={300}>
      <button
        onClick={disabled ? undefined : e => { e.stopPropagation(); onClick(); }}
        style={{
          width: 28, height: 28, borderRadius: 8,
          border: 'none', padding: 0,
          background: disabled ? 'transparent' : hov ? `${cfg.hover}1F` : 'transparent',
          color: disabled ? '#CBD5E1' : cfg.hover,
          opacity: disabled ? 1 : hov ? 1 : 0.55,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          cursor: disabled ? 'not-allowed' : 'pointer',
          transition: 'background 0.15s, opacity 0.15s', flexShrink: 0,
        }}
        onMouseEnter={() => { if (!disabled) setHov(true); }}
        onMouseLeave={() => setHov(false)}
      >
        {cfg.icon}
      </button>
    </Tooltip>
  );
}

// ── Pagination ────────────────────────────────────────────────────────────────

function buildPageList(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  if (current <= 4) return [1, 2, 3, 4, 5, 'end-ellipsis', total];
  if (current >= total - 3) return [1, 'start-ellipsis', total - 4, total - 3, total - 2, total - 1, total];
  return [1, 'start-ellipsis', current - 1, current, current + 1, 'end-ellipsis', total];
}

function Pagination({ current, total, onChange }) {
  const [hov, setHov] = useState(null);
  const [arrowHov, setArrowHov] = useState(null);

  const safeTotal = Math.max(1, total);
  const safeCurrent = Math.max(1, Math.min(current, safeTotal));
  const list = buildPageList(safeCurrent, safeTotal);
  const canPrev = safeCurrent > 1;
  const canNext = safeCurrent < safeTotal;

  const arrow = (name, enabled, icon, onClick, label) => (
    <Tooltip text={label} position="top" delay={300}>
      <button
        onClick={() => enabled && onClick()}
        disabled={!enabled}
        aria-label={label}
        onMouseEnter={() => enabled && setArrowHov(name)}
        onMouseLeave={() => setArrowHov(null)}
        style={{
          ...s.pageBtn,
          background: enabled && arrowHov === name ? DS.container : DS.surface,
          color: enabled ? DS.onVariant : '#CBD5E1',
          borderColor: DS.outline,
          cursor: enabled ? 'pointer' : 'not-allowed',
        }}
      >{icon}</button>
    </Tooltip>
  );

  return (
    <div style={s.pagination}>
      {arrow('prev', canPrev, <IcoChevLeft />, () => onChange(safeCurrent - 1), 'Página anterior')}

      {list.map(n => {
        const isGap = typeof n === 'string';
        const active = n === safeCurrent;
        const isHov = hov === n && !active;

        if (isGap) {
          return (
            <span key={n} style={{
              width: 32, height: 32, display: 'flex', alignItems: 'center',
              justifyContent: 'center', color: DS.onVariant, fontSize: '0.8125rem',
              userSelect: 'none',
            }}>...</span>
          );
        }

        return (
          <Tooltip key={n} text={active ? `Página ${n}, actual` : `Ir a la página ${n}`} position="top" delay={300}>
            <button
              onClick={() => !active && onChange(n)}
              onMouseEnter={() => setHov(n)}
              onMouseLeave={() => setHov(null)}
              aria-label={`Página ${n}`}
              aria-current={active ? 'page' : undefined}
              style={{
                ...s.pageBtn,
                background: active ? DS.primary : isHov ? DS.container : DS.surface,
                borderColor: active ? DS.primary : DS.outline,
                color: active ? DS.onPrimary : DS.onSurface,
                fontWeight: active ? 600 : 400,
                cursor: active ? 'default' : 'pointer',
              }}
            >{n}</button>
          </Tooltip>
        );
      })}

      {arrow('next', canNext, <IcoChevRight />, () => onChange(safeCurrent + 1), 'Página siguiente')}
    </div>
  );
}

function columnLayout(col) {
  return {
    width: col.width,
    minWidth: col.minWidth,
    maxWidth: col.maxWidth,
    textAlign: col.align || 'left',
  };
}

function sortRows(rows, sort) {
  if (!sort.accessor || !sort.direction) return rows;

  const collator = new Intl.Collator('es', { numeric: true, sensitivity: 'base' });
  const multiplier = sort.direction === 'asc' ? 1 : -1;

  return [...rows].sort((a, b) => {
    const av = a[sort.accessor];
    const bv = b[sort.accessor];

    if (av == null && bv == null) return 0;
    if (av == null) return 1;
    if (bv == null) return -1;

    return collator.compare(String(av), String(bv)) * multiplier;
  });
}

function nextSort(current, accessor) {
  if (current.accessor !== accessor) return { accessor, direction: 'asc' };
  if (current.direction === 'asc') return { accessor, direction: 'desc' };
  return { accessor: null, direction: null };
}

function columnSortType(col, rows) {
  if (col.sortType) return col.sortType;
  const sample = rows.find(row => row[col.accessor] !== null && row[col.accessor] !== undefined)?.[col.accessor];
  return typeof sample === 'number' ? 'number' : 'text';
}

// ── Table row with rounded ends ───────────────────────────────────────────────

function TableRow({ row, columns, actions, hasActions, actionWidth, expandable, onToggleExpand, onRowClick }) {
  const [hov, setHov] = useState(false);
  const bg = hov ? DS.container : DS.surface;
  const rowActions = actions.filter(a => !a.hidden?.(row));
  const clickable = expandable || !!onRowClick;

  function handleRowClick() {
    if (expandable) onToggleExpand(row);
    if (onRowClick) onRowClick(row);
  }

  return (
    <tr onClick={clickable ? handleRowClick : undefined} onMouseEnter={() => setHov(true)} onMouseLeave={() => setHov(false)} style={{ cursor: clickable ? 'pointer' : 'default' }}>
      {columns.map(col => (
        <td key={col.accessor} style={{
          ...s.td,
          ...columnLayout(col),
          ...(col.cellStyle || {}),
          background: bg,
        }}>
          {col.render ? col.render(row) : (row[col.accessor] ?? '-')}
        </td>
      ))}
      {hasActions && (
        <td className={Style.actionsCell} style={{ ...s.td, width: actionWidth, minWidth: actionWidth, background: bg, textAlign: 'right', overflow: 'visible', whiteSpace: 'nowrap' }}>
          <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
            {rowActions.map((a, i) => {
              const disabledMsg = typeof a.disabled === 'function' ? a.disabled(row) : false;
              return (
                <ActionBtn
                  key={i}
                  type={typeof a.type === 'function' ? a.type(row) : a.type}
                  onClick={() => a.callback(row)}
                  disabled={!!disabledMsg}
                  disabledTooltip={disabledMsg || ''}
                />
              );
            })}
          </div>
        </td>
      )}
    </tr>
  );
}

function EmptyHeightRow({ columns, hasActions, actionWidth }) {
  return (
    <tr aria-hidden="true">
      {columns.map(col => (
        <td key={col.accessor} style={{
          ...s.td,
          ...columnLayout(col),
          ...s.fillerCell,
        }}>&nbsp;</td>
      ))}
      {hasActions && <td style={{ ...s.td, width: actionWidth, minWidth: actionWidth, ...s.fillerCell }}>&nbsp;</td>}
    </tr>
  );
}

// ── GenericTable ──────────────────────────────────────────────────────────────

/**
 * Props:
 *   data      — array of row objects
 *   columns   — [{ header, accessor, render?, width?, minWidth?, align? }]
 *   actions   — [{ type: 'edit'|'delete'|'map', callback }]
 *   loading   — bool
 *
 *   Filter / Export / Add button live OUTSIDE in the TitleRow (schools.js).
 */
export function GenericTable({
  data = [],
  columns = [],
  actions = [],
  loading = false,
  onRowClick = null,
  style: containerStyle = {},
  filters = null,
  joined = false,       // la tabla continua la tarjeta de filtros de arriba
  renderExpandedRow,
}) {
  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState({ accessor: null, direction: null });
  const [expandedId, setExpandedId] = useState(null);

  const sorted = useMemo(() => sortRows(data, sort), [data, sort]);

  useEffect(() => { setCurrentPage(1); }, [pageSize, sort]);

  const totalPages = Math.max(1, Math.ceil(sorted.length / pageSize));
  const start = (currentPage - 1) * pageSize;
  const rows = sorted.slice(start, start + pageSize);

  useEffect(() => {
    setCurrentPage(page => Math.min(page, totalPages));
  }, [totalPages]);

  const hasActions = actions.length > 0;
  const actionWidth = hasActions ? Math.max(104, actions.length * 40) : 0;
  const expandable = typeof renderExpandedRow === 'function';
  const colSpan = columns.length + (hasActions ? 1 : 0);
  const from = sorted.length === 0 ? 0 : start + 1;
  const to = Math.min(start + pageSize, sorted.length);
  const rowSlots = 10;
  const fillerRows = !loading && rows.length > 0 ? Math.max(0, rowSlots - rows.length) : 0;

  return (
    <div
      className={`${Style.container} ${joined ? Style.joined : ''}`}
      style={{ ...s.container, ...(joined ? s.joinedContainer : null), ...containerStyle }}
    >

      {/* ── Filtros: viven dentro del mismo contenedor que la tabla ── */}
      {filters && (
        <div className={Style.filterBar} style={s.filterBar}>
          {filters}
        </div>
      )}

      {/* ── Table ── */}
      <div className={Style.tableWrap} style={s.tableWrap}>
        <table style={s.table}>
          <thead>
            <tr>
              {columns.map(col => {
                const sortType = columnSortType(col, data);
                const isSortable = col.sortable !== false && col.accessor !== '_checkbox';
                return (
                  <th key={col.accessor} style={{ ...s.th, ...columnLayout(col), ...(col.headerStyle || {}) }}>
                    {isSortable ? (
                      <button
                        type="button"
                        onClick={() => setSort(current => nextSort(current, col.accessor))}
                        style={{
                          ...s.sortButton,
                          justifyContent: col.align === 'center' ? 'center' : col.align === 'right' ? 'flex-end' : 'flex-start',
                        }}
                      >
                        <span>{col.header}</span>
                        <SortMark type={sortType} active={sort.accessor === col.accessor} direction={sort.direction} />
                      </button>
                    ) : (
                      <div style={{ display: 'flex', justifyContent: col.align === 'center' ? 'center' : col.align === 'right' ? 'flex-end' : 'flex-start', alignItems: 'center' }}>
                        {col.header}
                      </div>
                    )}
                  </th>
                );
              })}
              {hasActions && <th style={{ ...s.th, width: actionWidth, minWidth: actionWidth, textAlign: 'right' }}>Acciones</th>}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={colSpan} style={s.empty}><PulseLoader size={58} /></td></tr>
            ) : rows.length === 0 ? (
              <tr><td colSpan={colSpan} style={s.empty}>No se encontraron resultados</td></tr>
            ) : (
              <>
                {rows.map((row, i) => (
                  <React.Fragment key={row.id ?? i}>
                    <TableRow
                      row={row}
                      columns={columns}
                      actions={actions}
                      hasActions={hasActions}
                      actionWidth={actionWidth}
                      expandable={expandable}
                      onToggleExpand={(selected) => setExpandedId(current => current === selected.id ? null : selected.id)}
                      onRowClick={onRowClick}
                    />
                    {expandable && expandedId === row.id && (
                      <tr>
                        <td colSpan={colSpan} style={s.expandedCell}>{renderExpandedRow(row)}</td>
                      </tr>
                    )}
                  </React.Fragment>
                ))}
                {Array.from({ length: fillerRows }, (_, i) => (
                  <EmptyHeightRow key={`filler-${i}`} columns={columns} hasActions={hasActions} actionWidth={actionWidth} />
                ))}
              </>
            )}
          </tbody>
        </table>
      </div>

      {/* ── Pie: conteo + tamaño de página + paginación ── */}
      {!loading && (
        <div className={Style.tableFooter} style={s.footer}>

          <div style={s.footerMeta}>
            <span style={s.footerCount}>
              Mostrando {from} a {to} de {sorted.length} resultados
            </span>
            <select
              value={pageSize}
              onChange={e => setPageSize(Number(e.target.value))}
              style={s.pageSelect}
            >
              {[10, 25, 50].map(n => <option key={n} value={n}>Mostrar {n}</option>)}
            </select>
          </div>

          <Pagination
            current={currentPage}
            total={totalPages}
            onChange={setCurrentPage}
          />

        </div>
      )}

    </div>
  );
}

// ── Styles ────────────────────────────────────────────────────────────────────

const s = {
  // Contenedor: off-white, radio 8, borde 1px suave y sombra tecnica.
  container: {
    background: DS.surface,
    borderRadius: 8,
    border: `1px solid ${DS.outlineSoft}`,
    boxShadow: DS.shadow,
    overflow: 'hidden',
    fontFamily: TABLE_FONT,
    display: 'flex',
    flexDirection: 'column',
  },
  // Cuando los filtros van arriba, la tabla es la mitad de abajo de la tarjeta.
  joinedContainer: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderTop: 'none',
  },
  // Riel de filtros: primera fila del contenedor, sin tarjeta propia.
  filterBar: {
    display: 'flex', alignItems: 'center', gap: 8,
    flexWrap: 'wrap',
    padding: '10px 16px',
    borderBottom: `1px solid ${DS.outline}`,
    background: DS.surface,
    flexShrink: 0,
  },
  table: {
    width: '100%',
    minWidth: 720,
    tableLayout: 'fixed',
    borderCollapse: 'collapse',
  },
  tableWrap: {
    overflowX: 'auto',
    boxSizing: 'border-box',
  },
  // Cabecera: label-caps 11px sobre gris tecnico.
  th: {
    padding: '8px 16px',
    fontSize: '11px', fontWeight: 600, lineHeight: '14px',
    color: DS.onVariant, textTransform: 'uppercase', letterSpacing: '0.05em',
    textAlign: 'left', whiteSpace: 'nowrap',
    background: DS.container, boxSizing: 'border-box',
    borderBottom: `1px solid ${DS.outline}`,
    position: 'sticky', top: 0, zIndex: 1,
  },
  sortButton: {
    width: '100%',
    display: 'inline-flex', alignItems: 'center', gap: 6,
    border: 'none', background: 'transparent', padding: 0,
    color: 'inherit', cursor: 'pointer',
    font: 'inherit', letterSpacing: 'inherit', textTransform: 'inherit',
    textAlign: 'inherit',
  },
  // Celda: table-cell 13px/500, px-4 py-2.
  td: {
    padding: '8px 16px',
    fontSize: '13px', color: DS.onSurface,
    fontWeight: 400,
    height: TABLE_ROW_HEIGHT,
    verticalAlign: 'middle',
    lineHeight: '18px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    borderBottom: `1px solid ${DS.divider}`,
    transition: 'background 0.12s',
  },
  empty: {
    height: TABLE_ROW_HEIGHT * 8,
    textAlign: 'center',
    verticalAlign: 'middle',
    color: DS.muted, fontSize: '13px',
  },
  expandedCell: {
    padding: '0 16px 12px',
    background: DS.container,
    borderBottom: `1px solid ${DS.divider}`,
  },
  fillerCell: {
    height: TABLE_ROW_HEIGHT,
    color: 'transparent',
    background: DS.surface,
    borderBottom: `1px solid ${DS.divider}`,
    pointerEvents: 'none',
  },
  // ── Pie ──
  footer: {
    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: 12, flexWrap: 'wrap',
    padding: '10px 16px',
    borderTop: `1px solid ${DS.outline}`,
    background: DS.surface,
    flexShrink: 0,
  },
  footerMeta: { display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' },
  footerCount: {
    fontSize: '13px', color: DS.onVariant, fontWeight: 400, whiteSpace: 'nowrap',
  },
  pageSelect: {
    border: `1px solid ${DS.outline}`, borderRadius: 8,
    padding: '4px 8px', fontSize: '12px',
    color: DS.onVariant, background: DS.surface, cursor: 'pointer',
    outline: 'none', fontFamily: TABLE_FONT,
    fontWeight: 500,
  },
  pagination: {
    display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap',
  },
  // Boton de pagina: cuadrado de 30px, radio 8.
  pageBtn: {
    minWidth: 30, height: 30, padding: '0 6px',
    borderRadius: 8,
    border: `1px solid ${DS.outline}`,
    background: DS.surface,
    color: DS.onSurface,
    fontSize: '12px', fontWeight: 500,
    fontFamily: TABLE_FONT,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    transition: 'background 0.15s, border-color 0.15s, color 0.15s',
    flexShrink: 0,
  },
};
